import { MuvicardService } from '../../../../services/muvicard.service'
import { isRequestCanceled } from '../../../../services/axios.service'

/**
 * @return {Promise<Array|null>} the options, or `null` when a newer call superseded this one
 * (keep latest) - the caller must keep what it has instead of treating it as "no installments"
 */
export async function getMuvicardInstallmentOptions(value) {
	let options = []
	if (value === 0) return options

	let response
	try {
		response = await MuvicardService.GetInstallmentsOptions(value)
	} catch (error) {
		if (isRequestCanceled(error)) return null
		throw error
	}
	const array = response.data

	if (array.length > 0) {
		array.forEach((element) => {
			let interest = element.installments * element.installmentValue - value
			let installmentValue = element.installmentValue.$toReais()
			options.push({
				value: element.installments,
				label: `${element.installments}x de
						${installmentValue} ${
					element.withInterest
						? '(Juros: ' + interest.$toReais() + ')'
						: ' sem juros'
				}
						 `,
				interest,
			})
		})
	}
	return options
}
